export const environment = {
  auth_redirect_uri : 'https://sprinta.io/',
  production        : true,
  delay             : 400,
  apiBaseUrl        : 'https://api.sprinta.io/v1',
  agentApiBaseUrl   : 'https://agent-api.sprinta.io/v1',
  websocketUrl      : 'wss://u353magzwi.execute-api.ap-southeast-2.amazonaws.com/production',
  useBackendApi     : true
};
